export * from './home-paths.js'
export * from './state-storage.js'

export const name = '@tnega/home'
